import { ARGS_V, defOp, NEW_OUT } from "./internal/codegen";
const $ = (tpl, pre = NEW_OUT) => defOp(tpl, ARGS_V, ARGS_V, "o", 1, pre);
export const [asIVec, asIVec2, asIVec3, asIVec4] = $(([o, a]) => `${o}=${a}|0;`);
export const [asUVec, asUVec2, asUVec3, asUVec4] = $(([o, a]) => `${o}=${a}>>>0;`);
export const [asBVec, asBVec2, asBVec3, asBVec4] = $(([o, a]) => `${o}=!!${a};`);
export const [fromBVec, fromBVec2, fromBVec3, fromBVec4] = $(([o, a]) => `${o}=~~${a};`);
